import { memo } from 'react';
import { Modal, ModalBody, ModalContent } from '@heroui/react';
import { useModalAutoFocus } from '@/shared/lib/hooks';
import { CHAT_MODAL_WIDTH_CLASS } from '../../config/constants';
import { IconCheckCircle, IconClose } from '../icons';

export type ReportSuccessModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ReportSuccessModal = memo(({ isOpen, onClose }: ReportSuccessModalProps) => {
  useModalAutoFocus(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placement="center"
      hideCloseButton
      classNames={{
        base: `${CHAT_MODAL_WIDTH_CLASS} rounded-[28px] bg-white shadow-[0_24px_48px_rgba(30,30,30,0.12)]`,
        body: 'p-0',
        wrapper: 'px-2',
        backdrop: 'bg-black/30',
      }}
    >
      <ModalContent>
        <ModalBody>
          <div className="relative min-h-[229px] px-6 pb-11 pt-5 sm:px-[40px]">
            <div className="absolute right-5 top-5 sm:right-6">
              <button
                type="button"
                className="inline-flex h-8 w-8 items-center justify-center rounded-full text-[#757575] transition-colors hover:bg-black/[0.04] hover:text-[#1E1E1E]"
                onClick={onClose}
                aria-label="Close success modal"
              >
                <IconClose className="h-[18px] w-[18px]" />
              </button>
            </div>
            <div className="flex flex-col items-center pt-7 text-center sm:pt-8">
              <h2 className="text-[28px] font-semibold leading-[1.08] tracking-[-0.03em] text-[#2E2E2E]">
                Report submitted!
              </h2>
              <div className="mt-[26px] flex h-8 w-8 items-center justify-center text-green-tertiary">
                <IconCheckCircle className="h-7 w-7" />
              </div>
              <div className="mt-[22px] w-full border-t border-[#DEDEDE] px-[18px] pt-[18px]">
                <p className="text-[16px] font-normal leading-[1.4] text-[#1E1E1E]">
                  An administrator will review your request shortly
                </p>
              </div>
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
});

ReportSuccessModal.displayName = 'ReportSuccessModal';
